import { cn } from "../lib/utils";

const VERDICT_LABEL = {
  strong_buy: "STRONG BUY",
  buy: "BUY",
  conditional: "CONDITIONAL",
  pass: "PASS",
};

const VERDICT_STYLE = {
  strong_buy: "bg-verdict-strong text-white",
  buy: "bg-verdict-buy text-white",
  conditional: "bg-verdict-conditional text-white",
  pass: "bg-verdict-pass text-white",
};

export function VerdictPill({ verdict, className }) {
  return (
    <span
      data-testid={`verdict-pill-${verdict}`}
      className={cn(
        "inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-bold tracking-[0.08em] uppercase",
        VERDICT_STYLE[verdict] || "bg-slate-200 text-slate-700",
        className,
      )}
    >
      {VERDICT_LABEL[verdict] || verdict}
    </span>
  );
}

export function ScoreBadge({ score, verdict, size = "md" }) {
  const sizeClasses =
    size === "lg"
      ? "w-20 h-20 text-3xl"
      : size === "sm"
        ? "w-12 h-12 text-lg"
        : "w-16 h-16 text-2xl";
  const bgClass = {
    strong_buy: "bg-verdict-strong/10 border-verdict-strong text-verdict-strongText",
    buy: "bg-verdict-buy/10 border-verdict-buy text-verdict-buyText",
    conditional: "bg-verdict-conditional/10 border-verdict-conditional text-verdict-conditionalText",
    pass: "bg-verdict-pass/10 border-verdict-pass text-verdict-passText",
  }[verdict] || "bg-slate-100 border-slate-300 text-slate-700";

  return (
    <div
      data-testid={`score-badge-${verdict}`}
      className={cn(
        "flex items-center justify-center rounded-xl border-2 font-bold tabular",
        sizeClasses,
        bgClass,
      )}
    >
      {score}
    </div>
  );
}
